
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 56 56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M8.75 56h-7A1.75 1.75 0 010 54.25v-17.5A1.75 1.75 0 011.75 35h7a1.75 1.75 0 011.75 1.75v17.5A1.75 1.75 0 018.75 56zM3.5 52.5H7v-14H3.5zM36.75 35h-17.5a1.75 1.75 0 01-1.75-1.75v-10.5A1.751 1.751 0 0119.25 21h17.5a1.75 1.75 0 011.75 1.75v10.5A1.749 1.749 0 0136.75 35zM21 31.5h14v-7H21zM54.25 21h-7a1.75 1.75 0 01-1.75-1.75V1.75A1.75 1.75 0 0147.25 0h7A1.75 1.75 0 0156 1.75v17.5A1.75 1.75 0 0154.25 21zM49 17.5h3.5v-14H49z"}}),_c('path',{staticClass:"a",attrs:{"d":"M8.75 52.5A1.75 1.75 0 017 50.75v-10.5a1.75 1.75 0 011.75-1.75h3.514a8.743 8.743 0 008.236-5.831 1.751 1.751 0 011.653-1.169h10.826a1.751 1.751 0 011.721 2.05A22.839 22.839 0 0112.256 52.5zM10.5 49h1.75a19.336 19.336 0 0018.534-14h-7.461a12.249 12.249 0 01-11.057 7H10.5zm23.348-24.5H23.021a1.751 1.751 0 01-1.721-2.05A22.843 22.843 0 0143.743 3.5h3.507A1.75 1.75 0 0149 5.25v10.5a1.75 1.75 0 01-1.75 1.75h-3.514a8.743 8.743 0 00-8.236 5.831 1.75 1.75 0 01-1.652 1.169zM25.215 21h7.463a12.249 12.249 0 0111.055-7H45.5V7h-1.746a19.346 19.346 0 00-18.539 14z"}})])
          )
        }
      }
    